// Age helpers for the minor-protection signup flow.
//
// Players younger than MIN_PLAYER_AGE cannot create an account at all.
// Players in [MIN_PLAYER_AGE, MINOR_AGE_CEILING) need parental consent
// before scouts can find them. 18+ proceeds normally.

export const MIN_PLAYER_AGE = 13;
export const MINOR_AGE_CEILING = 18;

/**
 * Compute completed years between `dob` and today.
 * Returns null when the input isn't a valid YYYY-MM-DD or is in the future.
 */
export function computeAge(dob: string | null | undefined): number | null {
  if (!dob) return null;
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dob);
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  if (!year || !month || !day) return null;

  const birth = new Date(Date.UTC(year, month - 1, day));
  if (Number.isNaN(birth.getTime())) return null;
  // Reject obvious typos (e.g. 1899 → "you are 126").
  if (year < 1900) return null;

  const now = new Date();
  if (birth.getTime() > now.getTime()) return null;

  let age = now.getUTCFullYear() - year;
  const monthDiff = now.getUTCMonth() + 1 - month;
  if (monthDiff < 0 || (monthDiff === 0 && now.getUTCDate() < day)) age--;
  return age;
}
